module.exports = __webpack_public_path__ + "images/emoji/rowboat.be1625a6e4a157a51dd3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rowboat.png
// module id = iu4K
// module chunks = 1